import { THREE } from "mood-scene-lib";

let installed = false;

export function installDracoDecoderPath() {
  if (installed) return;
  installed = true;
  THREE.DefaultLoadingManager.setURLModifier((url: string) => {
    const match = url.match(/(?:^|\/)(lib\/draco\/.*)$/);
    return match ? `/${match[1]}` : url;
  });
}
